const GSTIN_ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const GSTIN_FORMAT = /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z\d]Z[A-Z\d]$/;

export const isValidGstin = (gstin: string): boolean => {
  if (gstin.length !== 15 || !GSTIN_FORMAT.test(gstin)) {
    return false;
  }

  let sum = 0;
  for (let index = 0; index < 14; index++) {
    const value = GSTIN_ALPHABET.indexOf(gstin.charAt(index));
    const product = value * ((index % 2) + 1);
    sum += Math.floor(product / 36) + (product % 36);
  }

  const checkValue = (36 - (sum % 36)) % 36;
  return gstin.charAt(14) === GSTIN_ALPHABET.charAt(checkValue);
};
